import React, { useState, useEffect, useCallback } from 'react';
import { Snackbar, Box, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const NotificationWithTimer = ({ open, onClose, message, position = 'bottom', time = 5 }) => {
    const [progress, setProgress] = useState(100);
    const [remainingTime, setRemainingTime] = useState(time);

    const handleClose = useCallback(() => {
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (!open && time > 0) return;

        setProgress(100);
        setRemainingTime(time);

        const interval = 100;
        const decrement = 100 / (time * 1000 / interval);

        const timer = setInterval(() => {
            setProgress((prev) => {
                const newProgress = prev - decrement;
                if (newProgress <= 0) {
                    clearInterval(timer);
                    handleClose();
                }
                return Math.max(newProgress, 0);
            });
            setRemainingTime((prev) => Math.max(prev - interval / 1000, 0));
        }, interval);

        return () => clearInterval(timer); // Очищаем таймер при удалении компонента
    }, [open, time, onClose]);

    // alert(window.Telegram.WebApp?.safeAreaInset?.bottom);

    return (
        <>
            <Snackbar
                open={open}
                onClose={onClose}
                anchorOrigin={{
                    vertical: position,
                    horizontal: 'center',
                }}
                sx={position === 'top' ? {
                    zIndex: 40000,
                    width: '100%',
                    top: window.Telegram.WebApp?.safeAreaInset?.top
                        ? `${window.Telegram.WebApp.safeAreaInset.top * 2 + 16}px`
                        : '16px',
                    background: "rgba(255, 255, 255, 0.04)",
                    borderRadius: "16px",
                    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                    backdropFilter: "blur(13.5px)",
                    WebkitBackdropFilter: "blur(13.5px)",
                } : {
                    zIndex: 40000,
                    width: '100%',
                    bottom: "16px",
                    background: "rgba(255, 255, 255, 0.04)",
                    borderRadius: "16px",
                    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                    backdropFilter: "blur(13.5px)",
                    WebkitBackdropFilter: "blur(13.5px)",
                }}
                ContentProps={{
                    sx: {
                        background: "transparent", // Убирает стандартный фон
                        '& .MuiSnackbarContent-root': {
                            // background: "rgba(255, 255, 255, 0.3)",
                            // borderRadius: "16px",
                            // boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                            // backdropFilter: "blur(15.5px)",
                            // WebkitBackdropFilter: "blur(15.5px)",
                        },
                        width: "100%",
                        display: 'flex'
                    },
                }}
                message={
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{
                            width: '100%',
                        }}
                    >
                        {
                            time > 0 && (
                                <Box
                                    position="relative"
                                    display="inline-flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{
                                        flexShrink: 0,
                                    }}
                                >
                                    <CircularProgress
                                        variant="determinate"
                                        value={progress}
                                        size={40}
                                        thickness={4}
                                        style={{ color: '#4983da' }}
                                    />
                                    <Typography
                                        variant="caption"
                                        component="div"
                                        color="white"
                                        sx={{ position: 'absolute', fontSize: '14px' }}
                                    >
                                        {Math.ceil(remainingTime)}
                                    </Typography>
                                </Box>
                            )
                        }
                        <Box
                            sx={{
                                flex: 1,
                                color: 'white',
                                fontSize: '14px',
                            }}
                        >
                            {message}
                        </Box>
                    </Box>
                }
            />
        </>
    );
};

NotificationWithTimer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    message: PropTypes.node.isRequired,
    position: PropTypes.oneOf(['top', 'bottom']),
    time: PropTypes.number,
};

export default NotificationWithTimer;
